<template>
  <div class="profil">
        <!-- main-area -->
        <main class="fix">
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="bg-img position-absolute top-0 start-0 w-100 h-100" data-background="assets/img/bg/breadcrumb_bg.jpg"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="breadcrumb__content">
                                <h2 class="title">Sekretariat</h2>
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><router-link to="/">Beranda</router-link></li>
                                        <li class="breadcrumb-item active" aria-current="page">Sekretariat</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                </div>
            </section>
            <!-- breadcrumb-area-end -->
            <!-- about-area -->
            <section class="about__area-five">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="about__content-five">
                                <div class="about__img-wrap-five">
                                <img :src="file_path+foto" alt="Apexa" />
                                </div>
                                <p v-html="isi"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- about-area-end -->
        </main>
        <!-- main-area-end -->
  </div>
</template>

<script>

export default {
  name: 'Profil',

  data () {
    return {
        file_path: this.$store.state.url.URL_APP + "uploads/",
        unit_kerja: this.$store.state.UNIT_KERJA,
        judul: "",
        isi: "",
        foto: "",
    }
  },

  methods: {
    getView: function() {
        fetch(this.$store.state.url.URL_SEKRETARIAT + "view", {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
        })
        .then(res => res.json())
        .then(res_data => {
        this.cek_load_data = false;
        var data = res_data[0];
        this.judul = data.judul;
        this.isi = data.isi;
        this.foto = data.foto;
        });
},
  },

  mounted () {
    this.getView();
  }
}
</script>
